module.exports = __webpack_public_path__ + "static/media/goodnest_app2_preview.53876d52.jpg";